/*
 * @Author: csu chen.su@murata.com
 * @Date: 2022-06-22 15:36:48
 * @LastEditors: csu chen.su@murata.com
 * @LastEditTime: 2022-07-28 10:38:23
 * @FilePath: \frontend\src\api\user.js
 */
import request from '@/utils/request';

// import store from '@/store';
import { functionListData } from './const/functionListData';
import { errorNotify } from '@/utils/errorNotification';
import { errorMsg, warningMsg } from '@/utils/message';
import { getTenantGWIdList } from '@/api/gateway';
import { roleId, topicType, serviceId } from '@/utils/const';
import { getServiceList } from '@/api/service';
import { getTopic, publishTopic } from '@/utils/mqtt';
import { getGatewaysServiceList } from '@/api/gatewayService';
import { ElMessage } from 'element-plus';
import { gatewayPermissionRequest, requireService } from '@/utils/serviceContext';

/**
 * @typedef {object} Result
 * @property {number} status - 実行結果のステータス
 * @property {any} data - 実行結果のデータ
 */

/**
 * @typedef {object} UserRole
 * @property {string} tenantId - テナントのID
 * @property {string} gatewayId - ゲートウェイのID
 * @property {string} serviceId - サービスのID
 * @property {string} userId - ユーザのID
 * @property {string} roleId - ロールのID
 */

/*
export function login() {
  // export function login(params) {
  // return request({
  //   url: '/user/login',
  //   method: 'post',
  //   data: params
  // })
  if (store.getters.user_name === '') {
    return new Promise(resolve => resolve({ status: 0, data: [{ token: 'testString' }] }));
  } else {
    //
  }
}
*/

/*
export function isLogin() {
  // return request({
  //   url: '/user/isLogin',
  //   method: 'post'
  // })

  // true: {status: 0, data: {user_name: user.user_name}}
  // false(not registered): {status: 0, data: {user_name: null}}
  if (store.getters.user_name === '') {
    return new Promise(resolve => resolve({ status: 0, data: { user_name: null } }));
  } else if (store.getters.user_name === 'admin') {
    return new Promise(resolve => resolve({ status: 0, data: { user_name: 'admin' } }));
  } else if (store.getters.user_name === 'manager') {
    return new Promise(resolve => resolve({ status: 0, data: { user_name: 'manager' } }));
  } else if (store.getters.user_name === 'guest') {
    return new Promise(resolve => resolve({ status: 0, data: { user_name: 'guest' } }));
  }
}
*/

/*
export function getUserRole() {
  if (store.getters.user_name === 'admin') {
    return new Promise((resolve) => resolve({ status: 0, data: { role_id: 1 } }));
  } else if (store.getters.user_name === 'manager') {
    return new Promise((resolve) => resolve({ status: 0, data: { role_id: 2 } }));
  } else if (store.getters.user_name === 'guest') {
    return new Promise((resolve) => resolve({ status: 0, data: { role_id: 3 } }));
  } else {
    return new Promise((resolve) => resolve({ status: 0, data: [{ cause: 'Unknown User role' }] }));
  }
}
*/

/*
export function logout() {
  // return request({
  //   url: '/user/logout',
  //   method: 'post'
  // })
  return new Promise(resolve => resolve({ status: 0, data: {} }));
}
*/

// TODO: add Pwd reset
export function updatePwd(data) {
  // return request({
  //   url: '/user/updatePwd',
  //   method: 'post',
  //   data: data,
  // });
}

/*
export function clearSession() {
  // return request({
  //   url: '/user/clearSession',
  //   method: 'post',
  // });
}
*/

/**
 * @param {Object} data 入力データオブジェクト
 * @param {string} data.isAdmin - adminかどうかの真偽値
 * @param {string} data.hasDashboardAccess - ダッシュボードアクセス権限の真偽値
 * @param {string} data.hasMaintenanceAccess - 保守アクセス権限の真偽値
 * @return {Promise<Result>} 実行結果のオブジェクト（data: ページ一覧）
 */
export function functionList(data) {
  let rows = null;
  if (data.isAdmin) {
    rows = functionListData.admin;
  } else {
    rows = functionListData.nonAdmin;
  }

  // ダッシュボードアクセス権限がない場合はフィルタリング
  if (!data.hasDashboardAccess) {
    rows = rows.filter((func) => func.func_name !== 'Dashboard');
  }

  // 保守アクセス権限がない場合はフィルタリング
  if (!data.hasMaintenanceAccess) {
    rows = rows.filter((func) => func.func_name !== 'Maintenance');
  }

  return new Promise((resolve) => resolve({ status: 0, data: rows }));
}

/**
 * @return {Promise<Object[]>} ユーザーのリスト（adminのみ実行可能）
 */
export async function getUserList() {
  const res_userList = [];
  try {
    const userList = await getUserIdList();
    const tenantGWIdList = await getTenantGWIdList();
    await Promise.all(
      userList.map(async (user) => {
        user.userRoleDataList = [];
        const userRoleList = await getUserRoleList({ user: user.userId });
        for (const gw of tenantGWIdList) {
          const gwUserRoleList = userRoleList.filter((userRole) => userRole.gatewayId === gw.devId);
          user.userRoleDataList.push({ [gw.devId]: gwUserRoleList });
        }
        res_userList.push(user);
      })
    );
  } catch {
    // TODO
    const res = {
      status: -2,
      data: [{ cause: errorMsg.e_request_failed_err }],
    };
    errorNotify(res);
  }
  const res_data = {
    count: res_userList.length,
    userList: res_userList,
  };
  return new Promise((resolve) => resolve({ status: 0, data: res_data }));
}

/**
 * @return {Promise<Object[]>} ユーザーのID関連情報のリスト（adminのみ実行可能）
 */
export async function getUserIdList() {
  let res_userList = [];
  try {
    res_userList = await request({
      url: `/users/methods/userlist`,
      method: 'get',
    });
  } catch {
    // TODO
    const res = {
      status: -2,
      data: [{ cause: errorMsg.e_request_failed_err }],
    };
    errorNotify(res);
  }
  return res_userList;
}

/**
 * @param {Object} data 入力データオブジェクト
 * @param {string} data.userName - ユーザーの名前
 * @return {Promise<Boolean>} ユーザーの名前の重複チェックの結果の真偽値
 */
export async function userNameDuplicateCheck(data) {
  console.log(data);
  let userNameDuplicated = false;
  const userNameDuplicateNotify = () => {
    ElMessage({
      message: warningMsg.Duplicated_User_Name,
      type: 'warning',
      duration: 5 * 1000,
      customClass: 'notify',
    });
  };
  try {
    const userList = await getUserIdList();
    if (userList.length > 0) {
      const duplicatedUser = userList.find((user) => user.userName === data.userName);
      if (duplicatedUser) {
        userNameDuplicateNotify();
        userNameDuplicated = true;
      }
    }
  } catch {
    userNameDuplicated = true;
  }
  return userNameDuplicated;
}

/**
 * @param {Object} data 入力データオブジェクト
 * @param {string} data.user - ユーザのID
 * @return {Promise<UserRole[]>} ユーザのロールのリスト（adminのみ実行可能）
 */
export async function getUserRoleList(data) {
  let res_userRoleList = [];
  try {
    res_userRoleList = await request({
      url: '/userroles/methods/getuserrolelist',
      method: 'get',
      params: {
        user_id: data.user,
      },
    });
  } catch {
    // TODO
    const res = {
      status: -2,
      data: [{ cause: errorMsg.e_request_failed_err }],
    };
    errorNotify(res);
  }
  return res_userRoleList;
}

/**
 * @param {Object} data 入力データオブジェクト
 * @param {string} data.user - ユーザのID
 * @param {UserRole[]} data.userRoleList - ユーザのロールのリスト
 * @param {string} data.userRoleList[].gatewayId - ロールのゲートウェイID
 * @param {string} data.userRoleList[].serviceId - ロールのサービスID
 * @param {string} data.userRoleList[].roleId - ロールのロールID
 * @return {Promise<Result>} 実行結果のオブジェクト（adminのみ実行可能）
 */
export async function saveUserRoleList(data) {
  let res = { status: 0 };
  try {
    await request({
      url: '/userroles/methods/saveuserrolelist',
      method: 'post',
      params: {
        user_id: data.user,
      },
      data: {
        userRoleList: data.userRoleList,
      },
    });
  } catch {
    // TODO
    res = {
      status: -2,
      data: [{ cause: errorMsg.e_request_failed_err }],
    };
    errorNotify(res);
  }
  return res;
}

/**
 * @param {Object} data 入力データオブジェクト
 * @param {string} data.tenant - テナントのID
 * @param {string} data.user - ユーザのID
 * @param {string} data.userName - ユーザの名前
 * @return {Promise<Result>} 実行結果のオブジェクト（adminのみ実行可能）
 */
export async function deleteUser(data) {
  let res = { status: 0 };
  try {
    await request({
      url: `/users/methods/deleteuser`,
      method: 'post',
      params: {
        user_id: data.user,
      },
    });
    const payload = {
      userName: data.userName,
    };
    const mqttData = {
      target: data.tenant,
      payload: payload,
    };
    const mqttTopic = getTopic(topicType.userDeleted, {
      tenant: data.tenant,
      target: data.tenant,
    });
    publishTopic(mqttTopic, mqttData);
  } catch {
    // TODO
    res = {
      status: -2,
      data: [{ cause: errorMsg.e_request_failed_err }],
    };
    errorNotify(res);
  }
  return res;
}

/*
export function updateUser(user) {
  return request({
    url: '/user/update',
    method: 'post',
    data: { user_id: user.user_id, user_name: user.user_name, password: user.password, role_id: user.role_id },
  });
}
*/

/**
 * @param {Object} data 入力データオブジェクト
 * @param {string} data.userName - ユーザのユーザー名
 * @param {UserRole[]} data.userRoleList - ユーザのロールのリスト
 * @param {string} data.userRoleList[].gatewayId - ロールのゲートウェイID
 * @param {string} data.userRoleList[].serviceId - ロールのサービスID
 * @param {string} data.userRoleList[].roleId - ロールのロールID
 * @return {Promise<Result>} 実行結果のオブジェクト（adminのみ実行可能）
 */
export async function createUser(data) {
  let res = { status: 0 };
  try {
    await request({
      url: `/users/methods/createuser`,
      method: 'post',
      data: {
        userName: data.userName,
        userRoleList: data.userRoleList,
      },
    });
  } catch {
    // TODO
    res = {
      status: -2,
      data: [{ cause: errorMsg.e_request_failed_err }],
    };
    errorNotify(res);
  }
  return res;
}

/**
 * @param {Object} data 入力データオブジェクト
 * @param {string} data.tenant - テナントのID
 * @param {string} data.user - ユーザのID
 * @param {string} data.userName - ユーザの名前
 * @return {Promise<Result>} 実行結果のオブジェクト（adminのみ実行可能）
 */
export async function promoteAdmin(data) {
  let res = { status: 0 };
  try {
    await request({
      url: `/users/methods/userpromote`,
      method: 'post',
      params: {
        user_id: data.user,
      },
    });
    const payload = {
      userName: data.userName,
    };
    const mqttData = {
      target: data.tenant,
      payload: payload,
    };
    const mqttTopic = getTopic(topicType.adminChanged, {
      tenant: data.tenant,
      target: data.tenant,
    });
    publishTopic(mqttTopic, mqttData);
  } catch {
    // TODO
    res = {
      status: -2,
      data: [{ cause: errorMsg.e_request_failed_err }],
    };
    errorNotify(res);
  }
  return res;
}

/**
 * @param {Object} data 入力データオブジェクト
 * @param {string} data.tenant - テナントのID
 * @param {string} data.user - ユーザのID
 * @param {string} data.userName - ユーザの名前
 * @return {Promise<Result>} 実行結果のオブジェクト（adminのみ実行可能）
 */
export async function demoteUser(data) {
  let res = { status: 0 };
  try {
    const serviceList = await getServiceList();
    const tenantGWIdList = await getTenantGWIdList();
    const gatewaysService = await getGatewaysServiceList({ gwIds: tenantGWIdList.map((gw) => gw.devId) });
    const userRoleList = [];
    for (const gw of tenantGWIdList) {
      for (const service of serviceList) {
        const gatewayService = gatewaysService[gw.devId];
        if (gatewayService && gatewayService.includes(service.serviceId)) {
          userRoleList.push({
            gatewayId: gw.devId,
            serviceId: service.serviceId,
            roleId: roleId.manager,
          });
        }
      }
    }
    if (userRoleList.length > 0) {
      res = await saveUserRoleList({
        user: data.user,
        userRoleList: userRoleList,
      });
    }
    if (res.status === 0) {
      await request({
        url: `/users/methods/userdemote`,
        method: 'post',
        params: {
          user_id: data.user,
        },
      });
      const payload = {
        userName: data.userName,
      };
      const mqttData = {
        target: data.tenant,
        payload: payload,
      };
      const mqttTopic = getTopic(topicType.adminChanged, {
        tenant: data.tenant,
        target: data.tenant,
      });
      publishTopic(mqttTopic, mqttData);
    }
  } catch {
    // TODO
    res = {
      status: -2,
      data: [{ cause: errorMsg.e_request_failed_err }],
    };
    errorNotify(res);
  }
  return res;
}

/**
 * @return {Promise<void>}
 */
export async function setLastLogin() {
  try {
    const date = new Date();
    await request({
      url: `/users/methods/userlastlogin`,
      method: 'post',
      data: {
        lastLogin: date.getTime(),
      },
    });
  } catch {
    // TODO
    const res = {
      status: -2,
      data: [{ cause: errorMsg.e_request_failed_err }],
    };
    errorNotify(res);
  }
}

/*
export function resetPassword(user) {
  return request({
    url: '/user/resetPwd',
    method: 'post',
    data: { user_name: user.user_name, password: user.password },
  });
}
*/

/**
 * @return {Promise<Boolean>} 実行ユーザーの存在確認
 */
export async function userCheck() {
  let userExist = false;
  try {
    const user = await request({
      url: '/users/methods/user',
      method: 'get',
    });
    if (user) {
      userExist = true;
    }
  } catch {
    // TODO
    const res = {
      status: -2,
      data: [{ cause: errorMsg.e_request_failed_err }],
    };
    errorNotify(res);
  }
  return userExist;
}

/**
 * @return {Promise<Boolean>} 実行ユーザーがadminかどうかの真偽値
 */
export async function adminCheck() {
  let adminCheck = false;
  try {
    const user = await request({
      url: '/users/methods/user',
      method: 'get',
    });
    if (user) {
      adminCheck = user.isAdmin;
    }
  } catch {
    // TODO
    const res = {
      status: -2,
      data: [{ cause: errorMsg.e_request_failed_err }],
    };
    errorNotify(res);
  }
  return adminCheck;
}

/**
 * Get all gateway service roles for current user
 * @return {Promise<UserRole[]>} User role list
 */
export async function getUserGatewayServiceRoles() {
  let roles = [];
  try {
    roles = await request({
      url: '/userroles/methods/myuserroles',
      method: 'get',
    });
  } catch {
    const res = {
      status: -2,
      data: [{ cause: errorMsg.e_request_failed_err }],
    };
    errorNotify(res);
  }
  return roles;
}

/**
 * Check dashboard access permission
 * @return {Promise<Boolean>} Dashboard access availability
 */
export async function dashboardAccessCheck() {
  try {
    const roles = await getUserGatewayServiceRoles();
    // Show dashboard if there's at least one role with serviceId=2 and roleId != disabled
    const hasDashboardAccess = roles.some(
      (role) => role.serviceId === serviceId.dashboard && role.roleId !== roleId.disabled
    );
    return hasDashboardAccess;
  } catch {
    // Hide on error
    return false;
  }
}

/**
 * Check maintenance access permission
 * @return {Promise<Boolean>} Maintenance access availability
 */
export async function maintenanceAccessCheck() {
  try {
    const roles = await getUserGatewayServiceRoles();
    // Show maintenance if there's at least one role with serviceId=3 and roleId != disabled
    const hasMaintenanceAccess = roles.some(
      (role) => role.serviceId === serviceId.maintenance && role.roleId !== roleId.disabled
    );
    return hasMaintenanceAccess;
  } catch {
    // Hide on error
    return false;
  }
}

/**
 * @param {Object} data 入力データオブジェクト
 * @param {string} data.gateway - テナントのID
 * @param {string} data.serviceId - ユーザのID
 * @return {Promise<string>} ゲートウェイとサービスに対するロール
 */
export async function getUserRole(data = {}) {
  let role = roleId.disabled;
  try {
    const userRole = await gatewayPermissionRequest(
      {
        url: '/userroles/methods/userrole',
        method: 'get',
        params: {
          gateway_id: data.gateway,
        },
      },
      {
        paramsRequireService: requireService({ serviceId: data.serviceId }),
      }
    );
    if (userRole) {
      role = userRole.roleId;
    }
  } catch {
    // TODO
    const res = {
      status: -2,
      data: [{ cause: errorMsg.e_request_failed_err }],
    };
    errorNotify(res);
  }
  return role;
}
